import React, { useEffect, useState } from "react";
import styles from "./payoutModal.module.css";
import { TextField, MenuItem, Button } from "@mui/material";

const PayoutModal = ({ onClose }) => {
  // console.log("user", selectedUser);

  return (
    <div className={styles.modalBackdrop}>
  <div className={styles.modalContainer}>
    <button className={`${styles.backButton} d-flex`} onClick={onClose}>
      &#x2190; Back
    </button>

    <h2 className={styles.modalTitle}>Reason for Errors</h2>
    <ol className={styles.modalList}>
      <li>Duplicate Entries</li>
      <li>Missing Entries</li>
      <li>Per txn cant be more than Monthly</li>
      <li>Daily txn cant be more than Monthly</li>
      <li>Wrong Phone number Format</li>
      <li>User cant be Admin</li>
      <li>Per txn limit exceeds 1 lakh</li>
      <li>Daily txn limit exceeds 1 lakh</li>
      <li>Name must contain at least 3 letters</li>
    </ol>
  </div>
</div>

  );
};

export default PayoutModal;
